import { mdiEye } from '@mdi/js';
import { Icon } from '@mdi/react';
import React from 'react';
import { Tooltip } from '../base/tooltip';
import * as S from './read-button.styles';

interface IReadButtonProps {
    count?: number;
    disabled?: boolean;
    onClick: () => void;
}
export const ReadButton: React.FunctionComponent<IReadButtonProps> = (props: IReadButtonProps): React.ReactElement => {
    const { count, disabled, onClick } = props;
    const message = count ? `Mark ${count} messages as Read` : 'Mark as Read';
    return (
        <Tooltip direction="top" title={<span>{message}</span>}>
            <S.ReadButton variant="outlined" onClick={onClick} disabled={disabled}>
                <Icon path={mdiEye} size={1} />
            </S.ReadButton>
        </Tooltip>
    );
};
